import { faEye, faEyeSlash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";

import {
  TextFieldControlled,
  TextFieldControlledProps,
} from "components/inputs/TextField/TextFieldControlled";
import { PASSWORD_RULES_VALIDATION } from "constants/formValidation";

export type PasswordFieldControlledProps = {
  passwordrules?: string;
} & TextFieldControlledProps;

const PasswordFieldControlled = (props: PasswordFieldControlledProps) => {
  const theme = useTheme();

  const [reveal, setReveal] = useState(false);

  return (
    <TextFieldControlled
      {...props}
      endAdornment={
        <IconButton
          data-testid="password-reveal"
          onClick={() => setReveal((prev) => !prev)}
          sx={{
            height: theme.spacing(3.5),
            width: theme.spacing(3.5),
          }}
          tabIndex={-1}
        >
          <FontAwesomeIcon
            color={reveal ? "inherit" : theme.palette.text.disabled}
            icon={reveal ? faEyeSlash : faEye}
            size="2xs"
          />
        </IconButton>
      }
      slotProps={{
        htmlInput: {
          ...props.slotProps?.htmlInput,
          passwordrules: PASSWORD_RULES_VALIDATION,
        },
        input: {
          ...props.slotProps?.input,
          sx: { pr: theme.spacing(0.75) },
        },
      }}
      type={reveal ? "text" : "password"}
    />
  );
};

export default PasswordFieldControlled;
